import { render, staticRenderFns } from "./activityInfo.vue?vue&type=template&id=234d1329&"
import script from "./activityInfo.vue?vue&type=script&lang=js&"
export * from "./activityInfo.vue?vue&type=script&lang=js&"
import style0 from "./activityInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports